import cn from 'classnames';
import PropTypes from 'prop-types';

import ContentBox from 'components/checkout/caap/ContentBox';
import { Row, RowSpan } from 'components/checkout/caap/Layout';
import { CheckoutCheckBox } from 'components/Mdl';
import { getFieldFocusEvents } from 'helpers/CheckoutUtils';
import styles from 'styles/components/checkout/caap/checkboxInput.scss';

const fieldFocusEvents = getFieldFocusEvents('is-focused');

const CheckboxInput = (params, { testId }) => {
  const {
    children,
    clearAfter,
    clearAfterWithSpace,
    isNoBorder = true,
    isPromoCheckbox,
    isSolo,
    header,
    isChecked,
    name,
    onChange,
    dataTestId = ''
  } = params;

  const labelClasses = cn(
    'mdl-checkbox',
    'is-upgraded',
    {
      'is-checked': isChecked
    }
  );

  return (
    <ContentBox
      clearAfter={clearAfter}
      clearAfterWithSpace={clearAfterWithSpace}
      isNoBorder={isNoBorder}
      isNoPadding={true}
      isPromoCheckbox={isPromoCheckbox}
      isSolo={isSolo}
      header={header}>
      <div className={styles.content}>
        <label htmlFor={name} className={labelClasses} {...fieldFocusEvents} data-test-id={testId(`${dataTestId}Label`)}>
          <CheckoutCheckBox
            id={name}
            name={name}
            checked={isChecked}
            onChange={onChange}
            data-test-id={testId(dataTestId)}/>
          <Row>
            <RowSpan span="12">
              <span className="mdl-checkbox__label">
                {children}
              </span>
              <span className="mdl-checkbox__focus-helper"></span>
              <span className="mdl-checkbox__box-outline">
                <span className="mdl-checkbox__tick-outline"></span>
              </span>
            </RowSpan>
          </Row>
        </label>
      </div>
    </ContentBox>
  );
};

CheckboxInput.contextTypes = {
  testId: PropTypes.func
};

export default CheckboxInput;
